import React, {useContext, useState} from "react";
import {
    Box, CardContent,
    Grid, ListItem,
    Typography
} from '@deere/fuel-react';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {RatingsCampaign} from "./RatingsCampaign";
import {useStyles} from "../shared/styles/Ratings";
import {
    CAMPAIGNS_CARD_TITLE,
    CAMPAIGNS_CARD_TITLE_SUPPLIER,
    GRO_TITLE,
    SRO_TITLE
} from "../shared/Constants";
import {CampaignContext} from "./Ratings";
import {NoData} from "../shared/NoData";
import {generateDisplayName} from "../shared/utils";

export const RatingsCampaignCard = ({isSupplier}) => {
    const classes = useStyles();
    const [expanded, setExpanded] = useState('panelContacts');
    const [expandedSupplier, setExpandedSupplier] = useState('panel1');
    const campaigns = useContext(CampaignContext);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleChangeSupplier = (panel) => (event, newExpanded) => {
        setExpandedSupplier(newExpanded ? panel : false);
    };

    return (
        <Grid item xs={12}>
            <Box p={2}>
                <div className={classes.root}>
                    <Accordion
                        expanded={expanded === 'panelContacts'}
                        onChange={handleChange('panelContacts')}
                    >
                        <AccordionSummary
                            className={classes.accordionSummary}
                            classes={{
                                expandIcon: classes.expandIcon,
                                content: classes.nestedContent,
                                expanded: classes.expanded
                            }}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Grid container>
                                <Grid item xs={7}>
                                    <Typography variant="h4">
                                        {isSupplier ? CAMPAIGNS_CARD_TITLE_SUPPLIER : CAMPAIGNS_CARD_TITLE}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    {campaigns && campaigns.suppliers && campaigns.suppliers.length !== 0 &&
                                    <Box display="flex" justifyContent="flex-end">
                                        {campaigns.suppliers && campaigns.suppliers.length > 1
                                            ? <>
                                                <Typography variant="h4">
                                                    {`${GRO_TITLE}:`}
                                                </Typography>
                                                <Typography variant="body1"
                                                            style={{paddingLeft: ".25rem", paddingRight: "1rem"}}>
                                                    {campaigns.suppliers[0].relationshipOwner !== null ? `${campaigns.suppliers[0].relationshipOwner}` : "-"}
                                                </Typography>
                                            </>
                                            : <>
                                                {campaigns.suppliers.length === 1
                                                    ? <>
                                                        {!isSupplier &&
                                                        <>
                                                            <Typography variant="h4">
                                                                {`${SRO_TITLE}:`}
                                                            </Typography>
                                                            <Typography variant="body1"
                                                                        style={{
                                                                            paddingLeft: ".25rem",
                                                                            paddingRight: "1rem"
                                                                        }}
                                                            >
                                                                {generateDisplayName(campaigns.suppliers[0].sro.firstName, campaigns.suppliers[0].sro.lastName)}
                                                            </Typography>
                                                        </>
                                                        }
                                                    </>
                                                    : <></>
                                                }
                                            </>
                                        }
                                    </Box>
                                    }
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                            {campaigns && campaigns.suppliers && campaigns.suppliers.length !== 0 &&
                                <Grid item xs={12}>
                                    {campaigns.suppliers.length > 1
                                        ? (campaigns.suppliers.map((item, index) => <React.Fragment key={item.supplierNumber}>
                                            {isSupplier
                                                ? <ListItem divider style={{padding: '.5rem .5rem .5rem 1.5rem'}}>
                                                    <Grid container alignItems="flex-start">
                                                        <Grid item xs={12} md={8}>
                                                            <Typography fontWeight="semibold">
                                                                {item.supplierName} - {parseInt(item.supplierNumber)}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <Box display="flex"
                                                                    justifyContent="flex-end">
                                                                <Typography
                                                                    fontWeight="semibold"
                                                                    variant="h4"
                                                                    display="inline"
                                                                    style={{marginRight: "0.5rem"}}
                                                                >
                                                                    SBM:
                                                                </Typography>
                                                                <Typography variant="body1"
                                                                    style={{paddingRight: "1rem"}}
                                                                >{
                                                                    item.sbm.firstName
                                                                        ? `${item.sbm.lastName}, ${item.sbm.firstName}`
                                                                        : item.sbm.userId
                                                                }</Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </ListItem>
                                                : <CardContent style={{padding: 0, marginTop: 10}}>
                                                    <div className={classes.root}>
                                                        <Accordion
                                                            expanded={expandedSupplier === `panel${item.supplierNumber}`}
                                                            onChange={handleChangeSupplier(`panel${item.supplierNumber}`)}
                                                        >
                                                            <AccordionSummary
                                                                className={classes.accordionSummary}
                                                                classes={{
                                                                    expandIcon: classes.expandIcon,
                                                                    content: classes.nestedContent,
                                                                    expanded: classes.expanded
                                                                }}
                                                                expandIcon={<ExpandMoreIcon/>}
                                                                aria-controls="panel1bh-content"
                                                                id="panel1bh-header"
                                                            >
                                                                <Grid container alignItems="flex-start">
                                                                    <Grid item xs={12} md={8}>
                                                                        <Typography fontWeight="semibold">
                                                                            {item.supplierName} - {parseInt(item.supplierNumber)}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Box display="flex"
                                                                            justifyContent="flex-end"
                                                                        >
                                                                            <Typography
                                                                                fontWeight="semibold"
                                                                                variant="h4"
                                                                                display="inline"
                                                                                style={{marginRight: "0.5rem"}}
                                                                            >
                                                                                SBM:
                                                                            </Typography>
                                                                            
                                                                            <Typography variant="body1"
                                                                                        style={{paddingRight: "1rem"}}
                                                                            >{
                                                                                item.sbm.firstName
                                                                                    ? `${item.sbm.lastName}, ${item.sbm.firstName}`
                                                                                    : item.sbm.userId
                                                                            }</Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </AccordionSummary>
                                                            <AccordionDetails
                                                                className={classes.accordionDetails}>
                                                                {item.campaigns.length > 0 ?
                                                                    <RatingsCampaign item={item} key={index}
                                                                                        index={index}/>
                                                                    :
                                                                    <NoData
                                                                        noDataMessage={{textLine1: "No campaigns sent"}}/>
                                                                }
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    </div>
                                                </CardContent>
                                            }
                                        </React.Fragment>)
                                    )
                                    : campaigns.suppliers.map((item, index) =>
                                        <React.Fragment key={item.supplierNumber}>
                                            {isSupplier ?
                                                <ListItem style={{padding: '.25rem .25rem .25rem 1.5rem'}}>
                                                    <Grid container alignItems="flex-start">
                                                        <Grid item xs={12} md={8}>
                                                            <Typography fontWeight="semibold">
                                                                {item.supplierName} - {parseInt(item.supplierNumber)}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <Box display="flex"
                                                                    justifyContent="flex-end">
                                                                <Typography
                                                                    fontWeight="semibold"
                                                                    variant="h4"
                                                                    display="inline"
                                                                    style={{marginRight: "0.5rem"}}>
                                                                    SBM:
                                                                </Typography>
                                                                <Typography variant="body1"
                                                                            style={{paddingRight: "1rem"}}
                                                                >{
                                                                    item.sbm.firstName
                                                                        ? `${item.sbm.lastName}, ${item.sbm.firstName}`
                                                                        : item.sbm.userId
                                                                }</Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </ListItem>
                                                :
                                                <>
                                                    {item.campaigns.length > 0
                                                        ? <RatingsCampaign item={item} index={index}/>
                                                        : <NoData
                                                            noDataMessage={{textLine1: "No campaigns sent"}}/>
                                                    }
                                                </>
                                            }
                                        </React.Fragment>
                                    )
                                }
                            </Grid>
                            }
                        </AccordionDetails>
                    </Accordion>
                </div>
            </Box>
        </Grid>
    );
}
